export const environment = {
  production: false,

  data: {
    // baseUrl: 'http://localhost:7071/api',
    baseUrl: 'https://dev-api.cloudotdr.com/mobile/v2',
    gatewayKey: '1ac71e353962437a94a58f4aa8dcb657',
  },

  environmentStoragePrefix: 'dev_',
};
